import API from "../api";
import api from "../api";
import { message } from "antd";
import Axios from "axios";
import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse("astraconfig@1234");
const iv = CryptoJS.enc.Utf8.parse("1234567890123456");

export function encrypt(text) {
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // return encrypted.toString();
  const ivCiphertext = iv.clone().concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(ivCiphertext);
}

export function decrypt(base64Input) {
  const rawData = CryptoJS.enc.Base64.parse(base64Input);

  // Extract IV and Ciphertext
  const extractedIV = CryptoJS.lib.WordArray.create(
    rawData.words.slice(0, 4),
    16
  ); // 16 bytes IV
  const ciphertext = CryptoJS.lib.WordArray.create(
    rawData.words.slice(4),
    rawData.sigBytes - 16
  );

  const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, {
    iv: extractedIV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export const getVarietiesAPI = async () => {
  return API.get("/varieties");
};

export const getStatesAPI = async () => {
  return API.get("/states");
};

export const getVarietiesWithStates = async () => {
  return API.get("/recommendations/monthly/price/qc_rules_filter");
};

// Volume visualization bar graph

export const getVolumeVisualizationData = async (
  source_type,
  model_run_list,
  branch_id,
  variety_id,
  basis_id
) => {
  const params = {
    info_source_type: source_type,
    model_runs: model_run_list,
    branch_id: branch_id,
    variety_id: variety_id,
    basis_id: basis_id,
  };
  return API.get(`/actual_vs_models`, { params: params });
};

//Tabular forecast apis

// Tab - I
export const getVolumeBuyingPlanState = async (run_month, qc_type) => {
  const params = {
    model_run: run_month,
    info_source_type: qc_type,
  };

  return Axios.all([
    API.get(`/dr_volume_buying_plan_state`, {
      params: params
    }),
    API.get(`/dr_buying_price_plan_state`, {
      params: params
    }),
  ]);
};

//Tab - II
export const getBuyingQuantities = async (run_month, qc_type) => {
  const params = {
    model_run: run_month,
    info_source_type: qc_type,
  };

  return Axios.all([
    API.get(`/dr_volume_buying_plan_state_variety`, {
      params: params
    }),
    API.get(`/dr_buying_percent_statewise`, {
      params: params
    }),
  ]);
};

//Tab - III
export const getVolumeBuyingPlanStateFactory = async (run_month, qc_type) => {
  const paramsForMajorTable = {
    model_run: run_month,
    info_source_type: qc_type,
  };
  const paramsForOtherTables = {
    info_source_type: qc_type,
  };

  return Axios.all([
    API.get(`/dr_volume_buying_plan_state_factory`, {
      params: paramsForMajorTable
    }),
    API.get(`/dr_indicative_freight`, {
      params: paramsForOtherTables
    }),
    API.get(`/dr_landed_cost`, {
      params: paramsForOtherTables
    }),
  ]);
};

// Weekly -graphs API

export const getWeeklyGraphData = async (state_id, variety_id, week_run) => {
  const weeklyGraphParams = {
    state_id,
    variety_id,
    week_run,
  };
  return API.get(`/recommendations/weekly/qc_rules`, {
    params: weeklyGraphParams,
  });
};
